import Option from "@p-ban/common/src/components/form/SelectBox/Option"
import Select from "@p-ban/common/src/components/form/SelectBox/Select"
import Spacer from "@p-ban/common/src/components/layout/Spacer"
import { removeWhiteSpaceCharacter } from "@p-ban/common/src/utils/StringUtils"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../../service/getNumberOfLayers"
import { isMetal, isRigid } from "../../../../../service/oneClickIs"
import type { OneClickFieldProps } from "../../../../../types"
import CheckBox from "../../../../components/1Click/form/CheckBox"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import HELP_LINKS from "../../../../constant/helpLinks"

import 捨て基板 from "./discardBoardMark.png"
import 異形外形スリット枠 from "./editVariantSlit.png"
import 実装認識マーク from "./recognizeMark.png"

const データ面付け編集サービス = ({ values, handlers, errors }: OneClickFieldProps) => {
  const numberOfLayers = getNumberOfLayers(values)
  const condition = getDisplayCondition(values)
  const { dataService: shouldShow } = condition
  const shouldShowOption = condition.discardBoardMark || condition.recognizeMark || condition.editVariantSlit

  const id = (() => {
    if (isRigid(values) && numberOfLayers === 1) return "リジッド1層"
    if (isRigid(values) && numberOfLayers === 2) return "リジッド2層"
    if (isRigid(values) && numberOfLayers === 4) return "リジッド4層"
    if (isRigid(values) && numberOfLayers === 6) return "リジッド6層"
    if (isRigid(values) && numberOfLayers === 8) return "リジッド8層"
    if (isRigid(values) && numberOfLayers === 10) return "リジッド10層"
    if (isRigid(values) && numberOfLayers === 12) return "リジッド12層"
    if (isMetal(values) && numberOfLayers === 1) return "メタル1層"
    if (isMetal(values) && numberOfLayers === 2) return "メタル2層"
  })()
  if (!id) return null

  const legend = "データ面付け編集\nサービス"

  return (
    <OneClickField isShow={shouldShow} legend={legend} helpURL={HELP_LINKS.データ面付け編集サービス}>
      <Select
        name={FIELD_NAMES.データ面付け編集サービス}
        value={values.dataService}
        onChange={handlers.select}
        aria-label={removeWhiteSpaceCharacter(legend)}
      >
        <Option value={ESTIMATE_CONSTANT.データ面付け編集サービス.なし.value}>なし</Option>
        <Option value={ESTIMATE_CONSTANT.データ面付け編集サービス[`同種面付(${id})`].value}>同種面付</Option>
        <Option value={ESTIMATE_CONSTANT.データ面付け編集サービス[`2種面付(${id})`].value}>2種面付</Option>
        <Option value={ESTIMATE_CONSTANT.データ面付け編集サービス[`3種面付(${id})`].value}>3種面付</Option>
        <Option value={ESTIMATE_CONSTANT.データ面付け編集サービス[`4種面付(${id})`].value}>4種面付</Option>
        <Option value={ESTIMATE_CONSTANT.データ面付け編集サービス[`5種面付(${id})`].value}>5種面付</Option>
        <Option value={ESTIMATE_CONSTANT.データ面付け編集サービス[`6種面付(${id})`].value}>6種面付</Option>
        <Option value={ESTIMATE_CONSTANT.データ面付け編集サービス[`7種面付(${id})`].value}>7種面付</Option>
        <Option value={ESTIMATE_CONSTANT.データ面付け編集サービス[`8種面付(${id})`].value}>8種面付</Option>
      </Select>
      <OneClickFieldMessages error={errors?.dataService}>
        {shouldShowOption && <p>※ご注文の際は、面付けイメージ図が必要となります。</p>}
      </OneClickFieldMessages>
      {shouldShowOption && (
        <>
          <Spacer size={12} />
          <OneClickFieldStack>
            {condition.discardBoardMark && (
              <CheckBox
                name={FIELD_NAMES.捨て基板}
                checked={values.discardBoardMark}
                onChange={handlers.checkbox}
                prefixImageSrc={捨て基板}
              >
                捨て基板
              </CheckBox>
            )}
            {condition.recognizeMark && (
              <CheckBox
                name={FIELD_NAMES.実装認識マーク}
                checked={values.recognizeMark}
                onChange={handlers.checkbox}
                prefixImageSrc={実装認識マーク}
              >
                実装認識マーク
              </CheckBox>
            )}
            {condition.editVariantSlit && (
              <CheckBox
                name={FIELD_NAMES.異形外形スリット枠}
                checked={values.editVariantSlit}
                onChange={handlers.checkbox}
                prefixImageSrc={異形外形スリット枠}
              >
                異形外形スリット枠
              </CheckBox>
            )}
          </OneClickFieldStack>
          {condition.discardBoardMark && <OneClickFieldMessages error={errors?.discardBoardMark} />}
          {condition.recognizeMark && <OneClickFieldMessages error={errors?.recognizeMark} />}
          {condition.editVariantSlit && <OneClickFieldMessages error={errors?.editVariantSlit} />}
        </>
      )}
    </OneClickField>
  )
}

export default データ面付け編集サービス
